import Helper from './Helper';

class CategoryLoader {

  constructor() {
    this.categories = Array.prototype.slice.call(document.querySelectorAll('.category-page'));
    this.placeArticle = new Array();
    if (Array.isArray(this.categories) && this.categories.length) {
      this.readMoreLink = `
      <a class="ns-link" href="REPLACE">
        <span class="ns-link__icon"><svg class="icon icon-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12"><g fill="none" fill-rule="evenodd">
            <polygon points="0 0 18 0 18 12 0 12"></polygon>
            <path fill="currentColor" d="M17.8351357,5.62407738 L12.0403884,0.156055143 C11.8205694,-0.0520183809 11.4650188,-0.0520183809 11.2445376,0.156055143 C11.0247186,0.363503821 11.0247186,0.699670654 11.2445376,0.907119332 L16.0779077,5.46849087 L0.563451777,5.46849087 C0.252262194,5.46849087 0,5.70655697 0,6.00023432 C0,6.29328682 0.252262194,6.53135292 0.563451777,6.53135292 L16.0779077,6.53135292 L11.2445376,11.0927245 C11.0247186,11.3001731 11.0247186,11.6369648 11.2445376,11.8444135 C11.3544471,11.9481378 11.4987861,12 11.642463,12 C11.786802,12 11.9304789,11.9481378 12.0410505,11.8444135 L17.8351357,6.37576641 C18.0549548,6.16831773 18.0549548,5.8321509 17.8351357,5.62407738"></path>
            </g>
          </svg>
        </span>
        <span class="ns-link__text">` + this.categories[0].dataset.readMore + `</span>
      </a>`;
      let i = 0;
      this.categories.forEach(category => {
        this.loadPage(category, i);
        i++;
      });
    }
  }

  loadPage(category, iteration) {
    const restUrl = category.dataset.restUrl;
    this.getData(restUrl).then((posts) => {
      for (let i = 0; i < posts.length; i++) {
        if (i == 0) {
          this.firstPost(posts[i], category, iteration);
        } else {
          this.placePost(posts[i], category, iteration);
        }
      }
      this.showContainer(iteration);
    });
  }

  getData(restUrl) {
    return fetch(restUrl)
      .then((response) => {
        return response.json();
      })
  }

  firstPost(post, category, iteration) {
    const article = document.createElement('article');
    article.innerHTML = post.content.rendered.replace('ns-img', 'ns-img loaded');
    const marginal = article.querySelector('.ns-marginal');
    let marginalContent;
    if(marginal && marginal !== undefined){
     marginalContent = marginal.innerHTML;
    } else{
      marginalContent = '';
    }
    if(marginalContent == ''){
      document.querySelector('body').classList.add('no-line');
    }

    const htmlContainer = `
    <div class="category-overview category-overview--` + iteration + `">
    <section class="category-overview__articles category-overview__articles--` + iteration + `" style="opacity: 0"><div id="js-append-here-` + iteration + `" class="category-overview__lines"></div></section>
    <aside class="category-overview__marginal">` + marginalContent + `</aside>
    </div>
    `;
    if(marginalContent != ''){
      marginal.parentNode.removeChild(marginal);
    }

    article.classList.add('category');
    article.innerHTML += htmlContainer;
    Helper.loadImagesInDomElement(article);
    category.appendChild(article);
    this.placeArticle[iteration] = document.querySelector('#js-append-here-' + iteration);
  }

  placePost(post, category, iteration) {

    const hasLead = !post.categories.includes(parseInt(category.dataset.noLead));
    let hasImg = !post.categories.includes(parseInt(category.dataset.noImg));
    const hasLink = !post.categories.includes(parseInt(category.dataset.noLink));

    let img;
    let lead;

    const element = document.createElement('div');
    element.innerHTML = post.content.rendered;
    if (hasImg) {
        const teaserImg = element.querySelector('.ns-img__teaser');
        let url;
        if(teaserImg && teaserImg !== undefined){
            url = teaserImg.dataset.src;
        } else{
          const bgImg = element.querySelector('.ns-img__bg-image');
          if(bgImg && bgImg != undefined){
            let style = bgImg.getAttribute('style');
            const a = style.split('background-image: url(');
            url = a[a.length - 1];
            url = url.slice(0, -1);
          }
        }
        if(url && url != undefined && !url.includes('data:image/svg+xml;charset=UTF')){
          img = '<a href="'+ post.link +'"><div class="overview-article__img loaded" style=\'background-image: url("'+url+'")\'></div></a>';
        } else{
          img = false;
      }
    }

    if (hasLead) {
      lead = element.querySelector('.ns-lead');

      if(!lead){
        lead = element.querySelector('.ns-paragraph');
      }
    }

    let title = element.querySelector('.ns-title-h1');

    if (!title) {
      title = element.querySelector('.ns-title-h2');
      if (!title) {
        title = element.querySelector('.ns-title-h3');
      }
    }

    if(title){
      const article = document.createElement('div');
      article.classList.add('overview-article');
      //article.href = post.link;
      if (hasImg && img && img != undefined) {
        article.innerHTML += img;
      }
      article.innerHTML += '<h2 class="overview-article__title">' + title.innerHTML + '</h2>';
      if (hasLead && lead) {
        if(hasLink){
          article.innerHTML += '<p class="overview-article__lead">' + Helper.cutString(lead.innerHTML, 300), +'</p>';
        } else{
          article.innerHTML += '<p class="overview-article__lead">' + lead.innerHTML + '</p>';
        }
      }
      if(hasLink){
        article.innerHTML += this.readMoreLink.replace('REPLACE', post.link);
      }

      Helper.appendInDom(this.placeArticle[iteration], article);
    }
  }

  showContainer(i) {
    const container = document.querySelector('.category-overview__articles--' + i);

    /*
    if (Helper.isTablet()) {
      container.style.height = ((container.offsetHeight / 2) + 170) + 'px';
    }

     */
    container.style.opacity = 1;
  }

}

export default CategoryLoader;
